<template>
    <div class="md-layout-item md-small-size-100">
        <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
                <div class="card-text">
                    <h4 class="title">Preset Category</h4>
                </div>
            </md-card-header>
            <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <md-field :class="[{ 'md-error': errors.has('required') },
                                        { 'md-valid': !errors.has('required') && touched.presetList.name }]">
                                <label>Name</label>
                                <md-input v-model="presetList.name"
                                          data-vv-name="required"
                                          v-validate="modelValidations.presetList.name"
                                          required
                                          type="text"></md-input>
                                <slide-y-down-transition>
                                    <md-icon class="error" v-show="errors.has('required')"
                                    >close</md-icon
                                    >
                                </slide-y-down-transition>
                                <slide-y-down-transition>
                                    <md-icon
                                            class="success"
                                            v-show="!errors.has('required') && touched.presetList.name "
                                    >done</md-icon
                                    >
                                </slide-y-down-transition>
                            </md-field>
                        </div>
                        <div class="md-layout-item">
                            <md-field>
                                <label>Type</label>
                                <md-select v-model="presetList.preset_type">
                                    <md-option value="item_size">Size</md-option>
                                </md-select>
                            </md-field>
                        </div>
                    </div>
                    <md-card-actions md-alignment="left">
                        <md-button class="md-success" native-type="submit"
                                   @click.native.prevent="validate">
                            {{ this.presetList.id ? 'Update' : 'Create' }}</md-button>
                    </md-card-actions>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
import { SlideYDownTransition } from "vue2-transitions";
export default {
    name: "PresentCategories",
    components: {
        SlideYDownTransition
    },
    data() {
        return {
            presetList: {
                preset_type: "item_size"
            },
            modelValidations: {
                presetList: {
                    name: {
                        required: true
                    }
                }
            },
            touched: {
                presetList: { name: false }
            }
        }
    },
    computed: {},
    watch: {
        required() {
            this.touched.presetList.name = true;
        },
    },
    methods: {
        validate(){
            this.$validator.validateAll().then(isValid => {
                    this.$emit("on-submit", this.tag, isValid);
                if (isValid == true) {
                    const newObj = { ...this.presetList };
                    const successHandler = () => this.$router.push('/preset_lists');
                    if(newObj.id){
                        this.$http.secured.put(`/v1/preset_lists/${newObj.id}`, newObj).then(successHandler);
                    } else {
                        this.$http.secured.post(`/v1/preset_lists`, newObj).then(successHandler);
                    }
                }
            })
        },
    },
    created() {
        if(this.$route.params.id){
            this.$http
                .secured
                .get(`/v1/preset_lists/${this.$route.params.id}`)
                .then(response => { this.presetList = response.data })
                .catch(error => alert(error))
        }
    },
    mounted() { }
}
</script>

<style scoped>

</style>
